import CaseFirstView from 'components/cases/common/CasesFirstView'
import OverView from 'components/cases/common/Overview/'
import Interview from 'components/cases/sevennet/Interview/'
// import CaseMaterials from 'components/cases/common/CaseMaterials/'
import CaseStudy from 'components/home/CaseStudy'
import { firstViewItem, overviewTitle, overviewItem, issueSolutionItems, caseCTAItem } from './SevennetItems'
import CaseCTA from 'components/cases/common/CaseCTA'
import FooterCTA from 'components/common/FooterCTA'

const Sevennet = () => {
  return (
    <section>
      <CaseFirstView firstViewItem={firstViewItem} />
      <OverView overviewItem={overviewItem} issueSolutionItems={issueSolutionItems} overviewTitle={overviewTitle} />
      <Interview />
      <CaseCTA {...caseCTAItem} />
      <FooterCTA />
      <CaseStudy enTitle="Case study" jaTitle="事例" tagType="h2" />
    </section>
  )
}

export default Sevennet
